import React from "react";

const AccessDenied = () => {
  return <div>You dont have permission to access use this feature.</div>;
};

export default AccessDenied;
